import { ActionItem } from "../../types";
import Compose, { ACTION_LEVEL } from "../Compose";

enum ACTION_ID {
    PAY_START = 109,
    PAY_RESULT = 110
}

const ACTION_MAP: { [K: string]: ACTION_ID } = {
    payStart: ACTION_ID.PAY_START,
    payResult: ACTION_ID.PAY_RESULT
};

export default class Pay extends Compose {
    compose(): ActionItem {
        const { level, item } = this.extraActionItem();

        // 支付行为需要关联到item级别
        if ([ACTION_LEVEL.ITEM].includes(level) === false) {
            return null;
        }

        const actionId = ACTION_MAP[this.event.type];

        // 未知事件
        if (typeof actionId === "undefined") {
            return null;
        }

        item.action_id = actionId;

        try {
            const evtData = this.event["data"];

            const data: { attr: number; value: number } =
                typeof evtData === "string" ? JSON.parse(evtData) : evtData;

            item.action_attr = data.attr;
            item.action_value = data.value;
        } catch (err) {}

        return item;
    }
}
